// extracted by mini-css-extract-plugin
export default {"resendBtn":"i4xsCZh7RUXqaF8LC9SjTQ==","backBtn":"DVbmKalEeVzDc1oNBe9KEA=="};